import { render, staticRenderFns } from "./FormDepartment.vue?vue&type=template&id=7274f596&scoped=true&"
import script from "./FormDepartment.vue?vue&type=script&lang=js&"
export * from "./FormDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7274f596",
  null
  
)

export default component.exports